import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ActionButtons } from '../others/ActionButtons';
import { Dialog } from '../others/Dialog';
import React from 'react';
import { useDataAuth } from '../../hooks/useDataAuth';
import { useNotification } from '../../hooks/useNotification';
import { useTranslation } from 'react-i18next';

export const UpdatePassword = ({ open, cancel, setLoading }) => {
  const { t } = useTranslation();
  const [{ handleCreateNewPassword, userSession }] = useDataAuth();
  const [sendNotification] = useNotification();

  const [newPassword, setNewPassword] = React.useState('');
  const [confirmNewPassword, setConfirmNewPassword] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&+])([A-Za-z\d$@$!%*?&]|[^ ]){8,15}$/;

    // if (!newPassword) {
    //   sendNotification(t("newPassword.passwordRequired"));
    //   return;
    // }

    if (!regex.test(newPassword)) {
      sendNotification({ msg: t("newPassword.passwordInfo"), variant: 'info' });
      return;
    }

    // if (newPassword !== confirmNewPassword) {
    //   sendNotification(t("newPassword.passwordMismatch"));
    //   return;
    // }

    handleCreateNewPassword(userSession.token, newPassword);
    sendNotification({ msg: t("newPassword.passwordUpadeSucces"), variant: 'info' });
    cancel();
  };

  return (
    <Dialog
      openDialog={open}
      title={t("newPassword.createNewPassword")}
      content={
        <Box display="flex" flexDirection="column" gap={2} p={2}>
          <TextField
            label={t("newPassword.newPasswordLabel")}
            type={showPassword ? 'text' : 'password'}
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}

            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <TextField
            label={t("newPassword.confirmNewPasswordLabel")}
            type={showConfirmPassword ? 'text' : 'password'}
            fullWidth
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Box>
      }
      actions={
        <ActionButtons
          onCancel={cancel}
          onSubmit={handleSubmit}
        />
      }
    />
  );
};